// import Swiper from 'swiper'
export default () => {
  window.elementorFrontend.hooks.addAction(
    'frontend/element_ready/visa-blog-listing.default',
    function ($element) {
      const eleSwiper = $('.blog-listing_swiper', $element)
      if (eleSwiper.length) {
        const sliderConfig = eleSwiper.data('slider')
        const asyncSwiper = window.elementorFrontend.utils.swiper //using swiper of elementor
        
        let breakpointMobile = {
          slidesPerView: sliderConfig.slides_per_view_mobile,
          spaceBetween: sliderConfig.space_between_mobile,
        }
        if (
          sliderConfig.slides_per_column_mobile &&
          sliderConfig.slides_per_column_mobile > 1
        ) {
          breakpointMobile = {
            ...breakpointMobile,
            slidesPerColumn: sliderConfig.slides_per_column_mobile,
            slidesPerColumnFill: 'row',
          }
        }
  
        let breakpointTablet = {
          slidesPerView: sliderConfig.slides_per_view_tablet,
          spaceBetween: sliderConfig.space_between_tablet,
        }
        if (
          sliderConfig.slides_per_column_tablet &&
          sliderConfig.slides_per_column_tablet > 1
        ) {
          breakpointTablet = {
            ...breakpointTablet,
            slidesPerColumn: sliderConfig.slides_per_column_tablet,
            slidesPerColumnFill: 'row',
          }
        }
  
        let breakpointDesktop = {
          slidesPerView: sliderConfig.slides_per_view,
          spaceBetween: sliderConfig.space_between,
        }
        if (
          sliderConfig.slides_per_column &&
          sliderConfig.slides_per_column > 1
        ) {
          breakpointDesktop = {
            ...breakpointDesktop,
            slidesPerColumn: sliderConfig.slides_per_column,
            slidesPerColumnFill: 'row',
          }
        }
        
        new asyncSwiper(eleSwiper, {
          loop: true,
          breakpoints: {
            // when window width is >= 320px
            320: breakpointMobile,
            // when window width is >= 640px
            640: breakpointTablet,
            // when window width is >= 992px
            1000: breakpointDesktop,
          },
          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        })
      }
    }
  )
}
